import axios from "axios";
import React, { useEffect, useState } from "react";
import styles from "./styles.css";
// reactstrap components
import {
  Input, 
} from "reactstrap";
import { URL_API } from "variable";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "react-quill/dist/quill.snow.css";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";

toast.configure();

function TagEdit() {
  const history = useHistory();
  const id = useParams();
  const [name, setName] = useState();
  const [tagFor, setFor] = useState();

  useEffect(() => {
    getTag();
  }, []);

  const onNameChange = (e) => {
    setName([e.target.value]);
  };

  const onTagForChange = (e) => {
    setFor([e.target.value]);
  };
  

  const getTag = () => {
    axios
      .get(URL_API + `auth/admin/tags/${id.id}/edit`)
      .then((response) => {
        if (response.status == 200) {
          setName(response.data.tag.name);
          setFor(response.data.tag.tag_for);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const onSubmit = (event) => {
    event.preventDefault();
    let formData = new FormData();
    formData.append("name", name);
    formData.append("tag_for", tagFor);

    axios
      .post(URL_API + `auth/admin/tags/update/${id.id}`, formData)
      .then((response) => {
        if (response.status == 200) {
          history.push("/admin/tags");
          toast.success("Tag Updated Successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <div className="content">
        <form onSubmit={(e) => onSubmit(e)}>
          <div className={`container-fluid`}>
            <div className={styles.HeroiImgBlogForm}>
              <div className={styles.paddingTopBottomBlogForm}>
                <h3 className={styles.HeroiImgTextBlogForm}>Update Tag</h3>
              </div>
            </div>
            <br />
            <div className="container">
              <div className={`form ${styles.blogPostForm}`}>
                <div className="form-group">
                  <label htmlFor="post-title" className={styles.labelPostForm}>
                    Name
                  </label>
                  <Input
                    name="title"
                    type="text"
                    //   class={`form-control ${styles.blogPostFormInput}`}
                    id="post-title"
                    required="required"
                    placeholder="audi"
                    value={name}
                    onChange={(e) => onNameChange(e)}
                  />
                </div>
                <br />

                <div className="form-group">
                  <label htmlFor="post-title" className={styles.labelPostForm}>
                    Tag For
                  </label>
                  <Input
                    name="title"
                    type="text"
                    //   class={`form-control ${styles.blogPostFormInput}`}
                    id="post-title"
                    // required="requixred"
                    placeholder="Enter   estate or blogs"
                    value={tagFor}

                    onChange={(e) => onTagForChange(e)}
                  />
                </div>
                <br />


                <Input
                  type="submit"
                  name="submit"
                  className={`btn btn-danger ${styles.blogPostFormBtn}`}
                  value="Submit"
                />
              </div>
              <br />
              <br />
            </div>
          </div>
          {/* <BlogForm handleChange={handleChange} /> */}
        </form>
      </div>
    </>
  );
}

export default TagEdit;
